// src/modules/Courier/pages/CourierModal/pages/ReceiptPage.jsx
import React, { useEffect, useState, useRef } from 'react';
import { useModalPage} from '../CourierModal.jsx';
import { useRouteStore } from '../../Route/useRouteStore';
import api from '../../../../services/api.js';
import styles from '../styles/ReceiptPage.module.css';
import NumericInput from '../components/NumericInput/NumericInput.js';

export default function ReceiptPage() {
  const { close } = useModalPage();
  const receipt = useRouteStore(s => s.selectedReceipt);
  
  // Локальный state
  const [editing, setEditing]     = useState(false);
  const [products, setProducts]   = useState([]);
  const [totalAmount, setTotalAmount] = useState('0.00');
  const [contacts, setContacts]   = useState(null);
  const [contactsVisible, setContactsVisible] = useState(false);
  const [contactsLoading, setContactsLoading] = useState(false);
  const [contactsError, setContactsError] = useState(null);
  const [error, setError]         = useState('');
  const { goTo } = useModalPage();

  // Инициализируем продукты
  useEffect(() => {
    if (!receipt) { close(); return; }
    setProducts(receipt.products.map(p => ({ ...p })));
    setEditing(false);
  }, [receipt, close]);

  // Пересчёт итога
  useEffect(() => {
    const sum = products.reduce((sum, p) => {
      const q = parseFloat(p.actual_quantity) || 0;
      const pr = parseFloat(p.price) || 0;
      const tq = parseFloat(p.actual_tare_sale_quantity) || 0;
      const tp = parseFloat(p.tare_price) || 0;
      return sum + q * pr + tq * tp;
    }, 0);
    setTotalAmount(sum.toFixed(2));
  }, [products]);

  const toggleContacts = async () => {
    if (contactsVisible) {
      setContactsVisible(false);
      return;
    }
    setContactsLoading(true);
    try {
      const resp = await api.get(`/receipts/${receipt.id}/contacts`);
      setContacts(resp.data ?? resp);
      setContactsVisible(true);
    } catch {
      setContactsError('Ошибка загрузки контактов');
    } finally {
      setContactsLoading(false);
    }
  };

  // Компонент для сворачиваемых комментариев
  const CollapsibleComment = ({ text }) => {
  const [expanded, setExpanded] = useState(false);
  const contentRef = useRef(null);
  const [isCollapsible, setIsCollapsible] = useState(false);

  useEffect(() => {
    if (contentRef.current) {
      setIsCollapsible(contentRef.current.scrollHeight > 50);
    }
  }, [text]);

  return (
    <div className={styles.collapsibleContainer}>
      <div
        ref={contentRef}
        className={styles.collapsibleContent}
        style={{ maxHeight: expanded ? 'none' : '50px', overflow: 'hidden' }}
      >
        {/* Здесь просто текст или ваш форматтер */}
        {text}
      </div>
      {isCollapsible && (
        <button
          className={styles.receiptToggleComment}
          onClick={() => setExpanded(e => !e)}
        >
          <i className={`bi ${expanded ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
        </button>
      )}
    </div>
  );
};

  const handleProductChange = (id, field, value) => {
    setProducts(prods =>
      prods.map(p => {
        if (p.id !== id) return p;
        // логика tare_price при нуле
        if (field === 'actual_tare_sale_quantity') {
          const newQ = Number(value);
          if (newQ === 0) return { ...p, actual_tare_sale_quantity: value, tare_price: 0 };
          if ((Number(p.actual_tare_sale_quantity) || 0) === 0 && newQ > 0) {
            return { ...p, actual_tare_sale_quantity: value, tare_price: 320 };
          }
        }
        return { ...p, [field]: value };
      })
    );
  };

  const handleEditClick = () => setEditing(e => !e);
  const handleCancel    = () => { setProducts(receipt.products); setEditing(false); };

  const handleSave = async () => {
    try {
      const updated = { ...receipt, products, to_pay: totalAmount };
      await api.patch(`/receipts/${receipt.id}`, updated);
      // обновляем стор
      useRouteStore.getState().updateReceipt(updated);
      setEditing(false);
    } catch (err) {
      setError('Не удалось сохранить');
    }
  };

  const handleClose = () => close();

  // Вот ваш единый return:
  return (
    <div className={styles.modalContainer}>
      {/* HEADER */}
      <div className={styles.header}>
        <div className={styles.titleWrapper}>
          <h2 className={styles.title} id="adaptive-title">
            {receipt.delivery_address}
          </h2>
        </div>
      </div>

      {/* BODY */}
      <div className={styles.body}>
        <div className={`${styles.row} ${styles.compact}`}>
          <i className="bi bi-geo-alt-fill" />
          <span className={styles.text}>{receipt.district}</span>
          <i className="bi bi-clock-fill" />
          <span className={styles.text}>{receipt.delivery_time}</span>
        </div>

        <div className={`${styles.row} ${styles.full}`}>
          <i className="bi bi-person-fill" />
          <span className={styles.text}>{receipt.client_name}</span>
        </div>

        <div className={`${styles.row} ${styles.compact}`}>
          <i className="bi bi-file-earmark-text-fill" />
          <span className={styles.text}>{receipt.contract_number}</span>
          <i className="bi bi-receipt" />
          <span className={styles.text}>{receipt.receipt_number}</span>
        </div>

        <div className={`${styles.row} ${styles.compact}`}>
          <i className="bi bi-credit-card-2-front-fill" />
          <span className={styles.text}>{receipt.payment_type}</span>
          <i className="bi bi-check-circle-fill" />
          <span className={styles.text}>{receipt.status}</span>
        </div>

        {/* Кнопка контактов 
        {!contactsVisible && (
          <div className={styles.showContactsButtonWrapper}>
            <button
              className={styles.showContactsButton}
              onClick={toggleContacts}
              disabled={contactsLoading}
            >
              {contactsLoading ? 'Загрузка...' : 'Показать контакты и комментарий'}
            </button>
          </div>
        )}

        {/* Контакты }
        {contactsVisible && contacts && (
          <div className={styles.comments}>
            {contacts.delivery_comment && (
              <div className={styles.commentWithIcon}>
                <i className="bi bi-truck" />
                <CollapsibleComment text={contacts.delivery_comment} />
              </div>
            )}
            {contacts.phone_number && (
              <div className={styles.commentWithIcon}>
                <i className="bi bi-telephone" />
                <CollapsibleComment text={contacts.phone_number} />
              </div>
            )}
            {contacts.contract_comment && (
              <div className={styles.commentWithIcon}>
                <i className="bi bi-chat-left-text" />
                <CollapsibleComment text={contacts.contract_comment} />
              </div>
            )}
          </div>
        )}
          */}
          <div className={styles.showContactsButtonWrapper}>
            <button
              className={styles.showContactsButton}
              onClick={() => goTo('contacts')}
            >
              Показать контакты и комментарий
            </button>
          </div>

        {/* Товары */}
        {products.length > 0 && (
          <div className={styles.products}>
            <div className={styles.editIconsContainer}>
              {editing ? (
                <>
                  <i
                    className={`bi bi-check-circle-fill ${styles.saveIcon}`}
                    onClick={handleSave}
                  />
                  <i
                    className={`bi bi-x-circle-fill ${styles.cancelIcon}`}
                    onClick={handleCancel}
                  />
                </>
              ) : (
                <i
                  className={`bi bi-pencil-square ${styles.editIcon}`}
                  onClick={handleEditClick}
                />
              )}
            </div>

            {products.map(prod => (
              <div key={prod.id} className={styles.productCard}>
                <div className={`${styles.productRow} ${styles.mainRow}`}>
                  <div className={styles.productHeader}>
                    <span className={styles.productName}>{prod.product_name}</span>
                    <div className={styles.productInfo}>
                      {/* Количество */}
                      <div className={styles.productField}>
                        <i className="bi bi-droplet" />
                        {editing ? (
                          <NumericInput
                            value={prod.actual_quantity}
                            onChange={v => handleProductChange(prod.id, 'actual_quantity', v)}
                          />
                        ) : (
                          <span>{prod.actual_quantity}</span>
                        )}
                      </div>
                      {/* Цена */}
                      <div className={styles.productField}>
                        <i className="bi bi-cash" />
                        {editing ? (
                          <NumericInput
                            value={prod.price}
                            step="0.01"
                            onChange={v => handleProductChange(prod.id, 'price', v)}
                          />
                        ) : (
                          <span>{prod.price} ₽</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Тара */}
                {prod.gtin === '04600840744001' && (
                  <div className={`${styles.productRow} ${styles.tareRow}`}>
                    <div className={styles.productHeader}>
                      <span className={styles.tareLabel}>Выкуп тары:</span>
                      <div className={styles.productInfo}>
                        <div className={styles.productField}>
                          <i className="bi bi-bucket" />
                          {editing ? (
                            <NumericInput
                              value={prod.actual_tare_sale_quantity || 0}
                              onChange={v => handleProductChange(prod.id, 'actual_tare_sale_quantity', v)}
                            />
                          ) : (
                            <span>{prod.actual_tare_sale_quantity || 0}</span>
                          )}
                        </div>
                        <div className={styles.productField}>
                          <i className="bi bi-cash-coin" />
                          {editing ? (
                            <NumericInput
                              value={prod.tare_price || 0}
                              step="0.01"
                              onChange={v => handleProductChange(prod.id, 'tare_price', v)}
                            />
                          ) : (
                            <span>{prod.tare_price || 0} ₽</span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* ИТОГО */}
      <div className={styles.totalSection}>
        <b>Итого к оплате:</b> {totalAmount} ₽
      </div>
      {receipt.status !== 'Не доставлено' && (
      <div className={styles.checkAction}>
      <button
        className={styles.notdeliveredButton}
        onClick={() => goTo('failure')}
      >
        Не доставлено
      </button>
  <button
  
    className={styles.checkButton}
    onClick={() => {
      const skipTypes = ["ПоСчету","Кредит","Взаимозачет","Дилер","БезОплаты"];
      const allScanned = (receipt.products ?? []).every(
        p => !p.is_marked || (p.marks?.length ?? 0) >= p.actual_quantity
      );
      if (allScanned && !skipTypes.includes(receipt.payment_type)) {
        // если чек уже пробит — открываем, иначе — формируем
        if (receipt.is_check_issued) {
          goTo('check');
        } else {
          goTo('dispatch');
        }
      } else {
        // во всех остальных случаях — сканирование
        goTo('dispatch');
      }
    }}
  >
    {(() => {
      const skipTypes = ["ПоСчету","Кредит","Взаимозачет","Дилер","БезОплаты"];
      const allScanned = (receipt.products ?? []).every(
        p => !p.is_marked || (p.marks?.length ?? 0) >= p.actual_quantity
      );
      if (allScanned && !skipTypes.includes(receipt.payment_type)) {
        return receipt.is_check_issued ? 'Посмотреть чек' : 'Сформировать чек';
      }
      return 'Сканировать';
    })()}
  </button>
</div>
)}
</div>
    
  );
}

// Компоненты FormattedComment и CollapsibleComment тоже можно вынести в свои файлы
// и подключать их здесь, заменив className на styles.collapsibleContainer и т.д.
